var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrapper"},[_c('video',{ref:"video",staticClass:"video-wrapper__video",attrs:{"controls":_vm.isMobile,"autoplay":"","muted":"","webkit-playsinline":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":`${_vm.url}?auth_token=${_vm.token}`,"type":"application/x-mpegURL"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }